import { Logger } from '_clean-code/utils/logger';
import jwtDecode from 'jwt-decode';

const TOLERANCE = 1000 * 65;

/**
 * helper method to validate  user token
 *
 * @param {*} token
 * @returns {boolean}
 */
export const validateToken = (token: any, useTolerance?: boolean): boolean => {
  if (!token) {
    return false;
  }
  try {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt.exp * 1000 + (useTolerance ? TOLERANCE : 0) >= Date.now();
  } catch (e) {
    Logger.error('Error decoding JWT', e);
    return false;
  }
};
